import{jsx as e}from"react/jsx-runtime";import r from"./DecadeView/Years.js";function a(a){return e("div",{className:"react-calendar__decade-view",children:e(r,Object.assign({},a))})}export{a as default};
